import { bizTypeMap } from '../../bizTypeMapping'
import { soapPost } from '../../ajaxSoap'
import { userInfo } from '@/global'

export const getReportLoadData = async (queryDoc) => {
  var ret = null
  await soapPost(bizTypeMap.getReportLoadData, queryDoc)
    .done(function (data) {
      ret = data
    })
  return ret
}

export const queryReportByCondition = async (queryDoc) => {
  var ret = null
  await soapPost(bizTypeMap.queryReportByCondition, queryDoc)
    .done(function (data) {
      ret = data
    })
  return ret
}

// 异步导出任务查询
export const queryExportTaskCondition = async (queryDoc) => {
  var ret = null
  await soapPost(bizTypeMap.queryExportTaskPage, queryDoc)
    .done(function (data) {
      ret = data
    })
  return ret
}

// 创建异步导出任务
export const createAsyncExportTask = async (queryDoc) => {
  var ret = null
  await soapPost(bizTypeMap.createExportCenterTask, queryDoc)
    .done(function (data) {
      ret = data
    })
  return ret
}

export const manhourLinkEfficiency = async (queryDoc) => {
  var ret = null
  await soapPost(bizTypeMap.manhourLinkEfficiency, queryDoc)
    .done(function (data) {
      ret = data
    })
  return ret
}
export const wmsManHourLinkCount = async (queryDoc) => {
  var ret = null
  await soapPost(bizTypeMap.wmsManHourLinkCount, queryDoc)
    .done(function (data) {
      ret = data
    })
  return ret
}

export const firstLegGetList = async (queryDoc) => {
  var ret = null
  await soapPost(bizTypeMap.firstLegGetList, queryDoc)
    .done(function (data) {
      ret = data
    })
  return ret
}
export const firstLegGetDetailList = async (queryDoc) => {
  var ret = null
  await soapPost(bizTypeMap.firstLegGetDetailList, queryDoc)
    .done(function (data) {
      ret = data
    })
  return ret
}
export const firstLegGetSendList = async (queryDoc) => {
  var ret = null
  await soapPost(bizTypeMap.firstLegGetSendList, queryDoc)
    .done(function (data) {
      ret = data
    })
  return ret
}
export const firstLegGetSendDetailList = async (queryDoc) => {
  var ret = null
  await soapPost(bizTypeMap.firstLegGetSendDetailList, queryDoc)
    .done(function (data) {
      ret = data
    })
  return ret
}
export const firstLegGetCheckList = async (queryDoc) => {
  var ret = null
  await soapPost(bizTypeMap.firstLegGetCheckList, queryDoc)
    .done(function (data) {
      ret = data
    })
  return ret
}
export const firstLegGetCheckDetailList = async (queryDoc) => {
  var ret = null
  await soapPost(bizTypeMap.firstLegGetCheckDetailList, queryDoc)
    .done(function (data) {
      ret = data
    })
  return ret
}
export const firstLegGetUnloadList = async (queryDoc) => {
  var ret = null
  await soapPost(bizTypeMap.firstLegGetUnloadList, queryDoc)
    .done(function (data) {
      ret = data
    })
  return ret
}
export const taskPend = async (queryDoc) => {
  var ret = null
  await soapPost(bizTypeMap.taskPend, queryDoc)
    .done(function (data) {
      ret = data
    })
  return ret
}
export const cancelTaskPend = async (queryDoc) => {
  var ret = null
  await soapPost(bizTypeMap.cancelTaskPend, queryDoc)
    .done(function (data) {
      ret = data
    })
  return ret
}
export const taskPick = async (queryDoc) => {
  var ret = null
  await soapPost(bizTypeMap.taskPick, queryDoc)
    .done(function (data) {
      ret = data
    })
  return ret
}
export const queryExportByCondition = async (queryDoc) => {
  var ret = null
  await soapPost(bizTypeMap.queryExportByCondition, queryDoc)
    .done(function (data) {
      ret = data
    })
  return ret
}
export const queryCarriersForCustomerBackLog = async (queryDoc) => {
  var ret = null
  await soapPost(bizTypeMap.queryCarriersForCustomerBackLog, queryDoc)
  .done(function (data) {
    ret = data
  })
return ret
}

// 首页积压看板（积压接口）
export const queryHomepageBacklogReport = async (queryDoc) => {
  var ret = null
  await soapPost(bizTypeMap.queryHomepageBacklogReport, queryDoc)
    .done(function (data) {
      ret = data
    })
  return ret
}

// 首页积压看板（作业中接口，底部4个小table数据）
export const queryHomepageProgressingReport = async (queryDoc) => {
  var ret = null
  await soapPost(bizTypeMap.queryHomepageProgressingReport, queryDoc)
    .done(function (data) {
      ret = data
    })
  return ret
}

// 首页积压看板（查询条件货主和承运商下拉）
export const queryHomepageCondition = async (queryDoc) => {
  var ret = null
  await soapPost(bizTypeMap.queryHomepageCondition, queryDoc)
    .done(function (data) {
      ret = data
    })
  return ret
}

export const inboundSu = async (queryDoc) => {
  var ret = null
  const parmas = Object.assign(queryDoc,{
    userCode:userInfo.userCode,
    userName:userInfo.userCode
  })
  await soapPost(bizTypeMap.firstLegGetUnloadList, parmas)
    .done(function (data) {
      ret = data
    })
  return ret
}



